import { connect } from 'react-redux'
import { string, bool } from 'prop-types'

import {
  getAppPayment,
  isAppInReview,
  isAuthorized,
  hasDirectInstallUrl,
  hasProductInCart,
  getTrustedProductUrl,
  canInstallApplications,
} from '@/store/selectors'
import { isBotEngine } from '@/utils/products'

import InstallButton from './Install'
import InstallPopUpButton from './InstallPopUp'
import NoAccessButton from './NoAccess'
import DirectInstallUrlButton from './DirectInstallUrl'
import TrustedProductButton from './TrustedProduct'
import SignInButton from './SignIn'

const InstallableButtonContainer = ({
  id,
  hasPopup,
  isBuyable,
  isProductInCart,
  isDirectInstallUrlFlow,
  isUserAuthorized,
  hasNoRightToInstall,
  isTrustedProductFlow,
  ...props
}) => {
  switch (true) {
    case hasNoRightToInstall:
      return <NoAccessButton id={id} {...props} />

    case !isUserAuthorized &&
      (hasPopup || (isDirectInstallUrlFlow && !isTrustedProductFlow)):
      return <SignInButton {...props} />

    case isTrustedProductFlow:
      return <TrustedProductButton id={id} {...props} />

    case hasPopup:
      return <InstallPopUpButton id={id} {...props} />

    case isDirectInstallUrlFlow:
      return <DirectInstallUrlButton id={id} {...props} />

    default:
      return <InstallButton id={id} {...props} />
  }
}

const mapStateToProps = (state, ownProps) => {
  const { id } = ownProps

  const hasPopup = isBotEngine(id)
  const payment = getAppPayment(state, id)
  const isInReview = isAppInReview(state, id)
  const isUserAuthorized = isAuthorized(state)
  const isDirectInstallUrlFlow = !!hasDirectInstallUrl(state, id)
  const isProductInCart = hasProductInCart(state, id)
  const isBuyable = !!payment && !isInReview
  const hasNoRightToInstall = isUserAuthorized && !canInstallApplications(state)
  const isTrustedProductFlow = !!getTrustedProductUrl(state, id)

  return {
    isProductInCart,
    hasPopup,
    isBuyable,
    isDirectInstallUrlFlow,
    hasNoRightToInstall,
    isUserAuthorized,
    isTrustedProductFlow,
  }
}

InstallableButtonContainer.propTypes = {
  id: string,
  hasPopup: bool,
  isProductInCart: bool,
  isBuyable: bool,
  isUserAuthorized: bool,
  hasNoRightToInstall: bool,
  isDirectInstallUrlFlow: bool,
  isTrustedProductFlow: bool,
}

export default connect(mapStateToProps)(InstallableButtonContainer)
